let mapsInitialized = false;
let callbacks = [];

window.initGoogleMaps = () => {
    mapsInitialized = true;

    callbacks.forEach(callback => callback());
};

export function initGoogleMapsAsync(callback) {
    if (mapsInitialized) {
        callback();
    } else {
        callbacks.push(callback);
    }
}
